module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm7.7 17.076l-6.96 6.644a1.053 1.053 0 0 1-1.434 0l-7.014-6.7a.94.94 0 0 1 0-1.368l1.434-1.368a1.048 1.048 0 0 1 1.434 0L14 16.97V9.002A1 1 0 0 1 14.998 8h2C17.55 8 18 8.45 18 9.002v8.022l2.836-2.682a1.043 1.043 0 0 1 1.43 0L23.7 15.71a.93.93 0 0 1 0 1.366z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-circle-4.js
// module id = 1113
// module chunks = 14